// extracted by mini-css-extract-plugin
module.exports = {"panel":"AreaPageHeader_panel__z08j2","headerContainer":"AreaPageHeader_headerContainer__gH3tT","gfxContainer":"AreaPageHeader_gfxContainer__gT35w"};